<div class="p-3 card-alerta">
  <div class="d-flex borda-card-alerta">
    <div style="width: 32px; height: 32px; border-radius: 50%">
      <img src="assets/imgs/logos/logo-pjus.svg" width="32px" alt="">
    </div>
    <span class="ms-2 texto-2 fw-400">Setor de parcerias  <span class="color-cinza-do-gelo">- {{ dataPendencia  ? moment(dataPendencia).format('DD/MM/YYYY HH:mm') : '-' }} </span></span>
  </div>
  <div><span class="texto-2 fw-400">{{ justificativa ? justificativa : '-' }}</span></div>
</div>
